var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9747 0.25C13.5975 0.25 14.1967 0.496751 14.6432 0.943252L20.3068 6.61852C20.7533 7.05327 21 7.65252 21 8.27527V21.4001C21 22.6926 19.9425 23.7501 18.65 23.7501H4.53821C3.2457 23.7501 2.19995 22.6926 2.19995 21.4001V2.60001C2.19995 1.3075 3.25745 0.25 4.54996 0.25H12.9747ZM13.6324 1.52027V6.19719C13.6324 6.76881 14.1001 7.2365 14.6717 7.2365H19.3487L13.6324 1.52027Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.01996,
    y: 8.47461,
    width: 7.05002,
    height: 1.175,
    rx: 0.587502,
    fill: "#292E52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.01996,
    y: 15.5254,
    width: 12.925,
    height: 1.175,
    rx: 0.587502,
    fill: "#292E52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.01996,
    y: 12,
    width: 12.925,
    height: 1.175,
    rx: 0.587502,
    fill: "#292E52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.01996,
    y: 19.0498,
    width: 12.925,
    height: 1.175,
    rx: 0.587502,
    fill: "#292E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignments);
export default __webpack_public_path__ + "static/media/assignments.b216f817.svg";
export { ForwardRef as ReactComponent };